import {PollerRetryState} from "./PollerPayload";

export default class PollerValidatorReply {
    constructor(public readonly state: PollerRetryState, public readonly data: any) {}
}
